import React from "react";
import Helmet from "react-helmet";
import Main from "../../components/main";
import Box from "../../components/box";
import H1 from "../../components/h1";
import A from "../../components/a";
import Img from "../../components/img";
import login from "./assets/login.png";
import google from "./assets/google.png";
import key from "./assets/key.png";
import main from "./assets/main.png";
import running from "./assets/running.png";
import success from "./assets/success.png";
import "./styles.css";

const Instructions = () => (
  <Main>
    <Helmet>
      <title>Ghast.io: Instructions</title>
      <meta
        name="description"
        content="Ghast Lag fix is the BEST Software for Improving Your Minecraft Connection, Shown to provide a BRUTAL combination of ..."
      />
    </Helmet>
    <Box>
      <div className="instructions">
        <H1>Installation And Usage Instructions</H1>
        <p>
          <span>1. </span> Download the installer from{" "}
          <A className="link" href="/download">
            https://ghast.io/download
          </A>
          .
        </p>
        <p>
          <span>2. </span> Open the setup file you just downloaded and wait for
          the installation to complete. Say yes to any permission prompt.
        </p>
        <p>
          <span>3. </span> The Ghast application should autmatically be added to
          your desktop as a shortcut.{" "}
          <b>Right click on the app and click 'Run as administrator'.</b> It
          won't work unless you give it administration permissions.
        </p>
        <p>
          <span>4. </span> After opening the application, you will see a login
          screen. <Img src={login} /> Either login with google{" "}
          <Img src={google} /> or login with your account key which can be
          acquired at{" "}
          <A className="link" href="https://ghast.io/key">
            https://ghast.io/key
          </A>
          . <Img src={key} />
        </p>
        <p>
          <span>4. </span> After logging in successfuly, you will be navigatated
          to the main screen. Enter your desired latency and click on{" "}
          <b>"Run Algorithm"</b>
          <Img src={main} />
        </p>
        <p>
          <span>5. </span>Wait for Ghast to finish running the algorithm. You
          will notice your computer's internet go off for a few seconds and then
          back on. <Img src={running} />
        </p>
        <p>
          <span>6. </span>If everything goes well, you will see a success
          message. <Img src={success} />
        </p>
      </div>
    </Box>
  </Main>
);

export default Instructions;



/** WEBPACK FOOTER **
 ** ./src/views/pages/instructions/index.js
 **/